<template>
    <el-dialog :title="id ? '编辑应用' : '创建应用'" :visible.sync="dialogVisible" width="600px" :close-on-click-modal="false"
        :show-close="true" custom-class="custom-dialog-center">
        <div class="dialog-content">
            <div class="form-item">
                <div class="label">应用类型 <span class="required">*</span></div>
                <div class="app-type-list">
                    <div class="app-type-item" v-for="item in appTypeList" :key="item.id"
                        :class="{ active: appForm.type === item.id }" @click="handleType(item.id)">
                        <div class="type-icon-container">
                            <img src="@/assets/images/ai.png" class="type-icon" />
                            <div class="type-name">{{ item.name }}</div>
                        </div>
                        <div class="type-desc">{{ item.desc }}</div>
                    </div>
                </div>
            </div>

            <div class="form-item">
                <div class="label">应用名称 <span class="required">*</span></div>
                <el-input v-model="appForm.name" maxlength="50" placeholder="给你的应用取个名称！不要担心，心随手摆" show-word-limit />
            </div>

            <div class="form-item">
                <div class="label">应用介绍</div>
                <el-input v-model="appForm.description" type="textarea" :rows="3" maxlength="250"
                    placeholder="这里可输入应用的简介，简短介绍应用用来做什么，如：应用怎么用、让它帮你解决了什么问题等。这是一个对用户如何使用你的应用的建议。你也可以不填写应用介绍。"
                    show-word-limit />
            </div>

            <div class="form-item">
                <div class="label">图标</div>
                <div class="upload-box">
                    <el-upload class="upload-trigger" :action="uploadUrl" :show-file-list="false"
                        :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload"
                        :http-request="customUpload" :headers="{ 'Authorization': $store.state.user.token }">
                        <img v-if="appForm.icon" :src="appForm.icon" class="preview-icon">
                        <i v-else class="el-icon-plus" :class="{ 'is-loading': uploadLoading }"></i>
                        <div slot="tip" class="el-upload__tip"></div>
                    </el-upload>
                </div>
            </div>

            <div class="form-item">
                <div class="label">访问链接</div>
                <div class="url-input-wrapper">
                    <div class="url-prefix">
                        <el-select v-model="appForm.inlayType" placeholder="输入方式">
                            <el-option label="请选择" value=""></el-option>
                            <el-option label="全屏模式" value="1"></el-option>
                            <el-option label="浮窗模式" value="2"></el-option>
                        </el-select>
                    </div>
                    <el-input v-model="appForm.accessUrl" placeholder="需要确保您这份应用的外部访问URL能够被正确访问" />
                </div>
            </div>

            <div class="form-item">
                <div class="label">其他设置 <span class="required">*</span></div>
                <div class="switch-item">
                    <span>应用开启</span>
                    <el-switch v-model="appForm.enabled" />
                </div>
                <div class="switch-item">
                    <span>共享应用</span>
                    <el-switch v-model="isShared" @change="switchChange" />
                    <span class="switch-desc">开启共享后，所有公司账号均可使用此应用</span>
                </div>
                <div class="switch-item">
                    <span>同步到KB</span>
                    <el-switch v-model="appForm.is_sync_kb" :disabled="id > 0 && appForm.is_sync_kb == 1" :active-value="1" :inactive-value="0"/>
                </div>
                <div class="permission-item" v-if="!isShared">
                    <div class="permission-title">配置访问权限</div>
                    <div class="permission-selectors">
                        <div class="selector-row">
                            <el-select v-model="appForm.permission_type" class="position-select"
                                @change="getPermissionInfo">
                                <el-option label="按角色" value="2"></el-option>
                                <el-option label="按人员" value="3"></el-option>
                            </el-select>
                            <el-select v-model="appForm.permission_info" placeholder="选择对应组，支持多选" class="user-select"
                                v-if="appForm.permission_type == 2" multiple filterable>
                                <el-option v-for="item in permission_info_list" :key="item.id" :label="item.role_name"
                                    :value="item.id"></el-option>
                            </el-select>
                            <el-select v-model="appForm.permission_info" placeholder="选择对应组，支持多选" class="user-select"
                                v-if="appForm.permission_type == 3" multiple filterable>
                                <el-option v-for="item in permission_info_list" :key="item.id" :label="item.name"
                                    :value="item.id"></el-option>
                            </el-select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <template #footer>
            <div class="dialog-footer">
                <el-button @click="closeDialog" size="mini">取消</el-button>
                <el-button type="primary" @click="createApp" size="mini" :loading="submitLoading">{{ id ? '更新' : '创建'
                    }}</el-button>
            </div>
        </template>
    </el-dialog>
</template>
<script>
import { getDictionary } from '@/api/common';
import { addAgent, updateAgent, getAgentDetail } from '@/api/agent';
import { getRolesList } from '@/api/roles';
import { getUserTryList } from '@/api/user';
import axios from 'axios';

export default {
    name: 'CreateAgent',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        id: {
            type: [String, Number],
            default: ''
        }
    },
    data() {
        return {
            appTypeList: [],
            uploadUrl: window.API_URL + '/api/upload',
            permission_info_list: [],
            appForm: {
                type: '',
                name: '',
                permission_info: [],
                permission_type: '',
                description: '',
                icon: '',
                accessUrl: '',
                enabled: true,
                inlayType: '', // 默认全屏模式
                positionType: '',
                userIds: [],
                is_sync_kb: 1
            },
            isShared: false,
            uploadLoading: false,
            submitLoading: false,
            // 分片上传的配置
            chunkSize: 2 * 1024 * 1024, // 2MB 一片
            chunkCount: 0,
            currentChunk: 0
        }
    },
    computed: {
        dialogVisible: {
            get() {
                return this.visible;
            },
            set(val) {
                this.$emit('update:visible', val);
            }
        }
    },
    watch: {
        visible(val) {
            if (val) {
                this.getAppTypes();
                // 如果有ID，则获取详情数据
                if (this.id) {
                    this.getAgentInfo();
                } else {
                    this.resetForm();
                }
            }
        }
    },
    methods: {
        getAgentInfo() {
            getAgentDetail(this.id).then(res => {
                if (res.code === 0) {
                    const data = res.data;
                    this.appForm = {
                        type: data.dictionary_id,
                        name: data.title,
                        description: data.desc,
                        icon: data.thumb,
                        accessUrl: data.link,
                        enabled: data.status == 1,
                        inlayType: data.inlay_type ? data.inlay_type.toString() : '',
                        isShared: data.is_shared == 1,
                        positionType: '',
                        userIds: data.role_ids ? data.role_ids.split(',').map(Number) : [],
                        permission_type: data.permission_type ? data.permission_type + '' : '',
                        permission_info: data.permission_info,
                        is_sync_kb: data.is_sync_kb
                    };
                    if (data.permission_type == 2) {
                        getRolesList({ page: 1, limit: 1000 }).then(res => {
                            this.permission_info_list = res.data;
                        });
                    }
                    if (data.permission_type == 3) {
                        getUserTryList({ page: 1, limit: 1000 }).then(res => {
                            this.permission_info_list = res.data;
                        });
                    }
                    this.isShared = data.permission_type == 1 ? true : false;
                } else {
                    this.$message.error(res.msg || '获取应用详情失败');
                }
            }).catch(err => {
                this.$message.error('获取应用详情失败: ' + err.message);
            });
        },
        switchChange(e) {
            if (e) {
                this.appForm.permission_type = 1;
                this.appForm.permission_info = [];
            } else {
                this.appForm.permission_type = '';
                this.appForm.permission_info = [];
            }
        },
        getPermissionInfo() {
            this.permission_info_list = [];
            this.appForm.permission_info = [];
            if (this.appForm.permission_type == 2) {
                getRolesList({ page: 1, limit: 1000 }).then(res => {
                    this.permission_info_list = res.data;
                });
            }
            if (this.appForm.permission_type == 3) {
                getUserTryList({ page: 1, limit: 1000 }).then(res => {
                    this.permission_info_list = res.data;
                });
            }
        },
        handleType(id) {
            if(this.id){
                return;
            }
            this.appForm.type = id;
        },
        getAppTypes() {
            getDictionary(11).then(res => {
                this.appTypeList = res.data;
            });
        },
        handleAvatarSuccess(res, file) {
            if (res.code && res.code === 0) {
                this.appForm.icon = res.data.path;
                this.uploadLoading = false;
            } else {
                this.$message.error('上传失败');
                this.uploadLoading = false;
            }
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
            const isLt2M = file.size / 1024 / 1024 < 10;

            if (!isJPG) {
                this.$message.error('上传图标只能是 JPG/PNG 格式!');
                return false;
            }
            if (!isLt2M) {
                this.$message.error('上传图标大小不能超过 10MB!');
                return false;
            }
            this.uploadLoading = true;
            return true;
        },
        // 自定义上传方法，实现分片上传
        async customUpload(options) {
            const { file } = options;
            this.uploadLoading = true;

            try {
                await this.uploadSingleChunk(file, options);
            } catch (error) {
                this.uploadLoading = false;
                this.$message.error('上传失败: ' + error.message);
                options.onError(error);
            }
        },
        // 单片上传
        async uploadSingleChunk(file, options) {
            const formData = new FormData();
            formData.append('file', file);

            const response = await axios.post(this.uploadUrl, formData, {
                headers: {
                    'Authorization': this.$store.state.user.token,
                    'Content-Type': 'multipart/form-data'
                }
            });

            if (response.data.code === 0) {
                this.appForm.icon = response.data.data.path;
                this.uploadLoading = false;
                options.onSuccess(response.data);
            } else {
                throw new Error(response.data.msg || '上传失败');
            }
        },
        closeDialog() {
            this.dialogVisible = false;
            this.resetForm();
        },
        createApp() {
            // 表单验证
            if (!this.appForm.type) {
                this.$message.error('请选择应用类型');
                return;
            }
            if (!this.appForm.name) {
                this.$message.error('请输入应用名称');
                return;
            }
            this.submitLoading = true;

            // 构建请求数据
            const requestData = {
                dictionary_id: this.appForm.type,
                title: this.appForm.name,
                thumb: this.appForm.icon,
                desc: this.appForm.description,
                tags: '',
                status: this.appForm.enabled ? 1 : 0,
                inlay_type: parseInt(this.appForm.inlayType) || 0,
                link: this.appForm.accessUrl,
                permission_type: this.appForm.permission_type,
                permission_info: this.appForm.permission_info,
                is_shared: this.isShared ? 1 : 0,
                is_sync_kb: this.appForm.is_sync_kb
            };

            if (this.id) { 
                delete requestData.is_sync_kb
            }
            // 判断是新增还是编辑
            const request = this.id ? updateAgent(this.id, requestData) : addAgent(requestData);

            request.then(res => {
                if (res.code === 0) {
                    this.$message.success(this.id ? '更新成功' : '创建成功');
                    this.dialogVisible = false;
                    this.resetForm();
                    this.$emit('created', res.data);
                } else {
                    this.$message.error(res.msg || (this.id ? '更新失败' : '创建失败'));
                }
                this.submitLoading = false;
            }).catch(err => {
                this.$message.error((this.id ? '更新' : '创建') + '失败: ' + err.message);
                this.submitLoading = false;
            });
        },
        resetForm() {
            this.appForm = {
                type: '',
                name: '',
                description: '',
                icon: '',
                accessUrl: '',
                enabled: true,
                inlayType: '1',
                isShared: false,
                positionType: '',
                userIds: [],
                permission_type: '',
                permission_info: [],
                is_sync_kb: 1
            };
            this.isShared = false;
            this.chunkCount = 0;
            this.currentChunk = 0;
        }
    }
}
</script>

<style lang="scss" scoped>
.dialog-content {
    padding: 0 10px;

    .form-item {
        margin-bottom: 20px;

        .label {
            font-size: 14px;
            margin-bottom: 15px;
            color: #333;
            font-weight: 500;

            .required {
                color: #f56c6c;
                margin-left: 2px;
            }
        }
    }

    .app-type-list {
        display: flex;
        gap: 10px;
        margin-top: 15px;

        .app-type-item {
            flex: 1;
            border: 1px solid #EBEEF5;
            border-radius: 6px;
            padding: 12px;
            cursor: pointer;
            transition: all 0.3s;

            &.active {
                border-color: #409EFF;
                background-color: #F0F8FF;
            }

            .type-icon {
                width: 20px;
                height: 20px;
            }

            .type-name {
                font-size: 16px;
                font-weight: 500;
            }

            .type-desc {
                font-size: 12px;
                color: #909399;
                line-height: 1.4;
            }

            .type-icon-container {
                display: flex;
                align-items: center;
                gap: 5px;
                margin-bottom: 10px;
            }
        }
    }

    .upload-box {
        .upload-trigger {
            width: 64px;
            height: 64px;
            border: 1px dashed #d9d9d9;
            border-radius: 6px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            .preview-icon {
                width: 100%;
                height: 100%;
                object-fit: cover;
                border-radius: 6px;
            }

            .upload-placeholder {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 100%;
                height: 100%;

                .upload-icon {
                    width: 24px;
                    height: 24px;
                }
            }
        }
    }

    .url-input-wrapper {
        display: flex;

        .url-prefix {
            margin-right: 10px;
        }
    }

    .switch-item {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 20px;

        .switch-desc {
            font-size: 12px;
            color: #909399;
            margin-left: 5px;
        }
    }

    .permission-item {

        .permission-title {
            font-size: 14px;
            font-weight: 500;
            margin-bottom: 10px;
        }

        .permission-selectors {
            margin-top: 10px;

            .selector-row {
                display: flex;
                gap: 10px;

                .position-select {
                    width: 90px;
                }

                .user-select {
                    flex: 1;
                }
            }
        }
    }
}
</style>
